import { createReducer, createSelector } from '@reduxjs/toolkit'
import calendarTypes from './types'
import userTypes from '../user/types'

import { map, filter, find, orderBy } from 'lodash'

export { default as actions } from './actions'

export const selectVisibleCalendars = createSelector(
  (state) => state.linkedCalendars,
  (calendars) => filter(calendars, 'visible'),
)

const hydrateState = (state, config = {}) => {
  const formattedCalendars = map(config.ReadCalendars, (record) => {
    const newCalendar = {
      id: record.Id,
      label: record.Label,
    }
    const currentCalendarState = find(state, { id: record.Id })
    newCalendar.visible = !currentCalendarState || currentCalendarState.visible
    return newCalendar
  })
  return orderBy(formattedCalendars, 'id', 'asc')
}

export default createReducer([], {
  [userTypes.FETCH_USER_SUCCESS]: (state, action) => {
    return hydrateState(state, action.payload.CalendarConfig)
  },
  [calendarTypes.SHOW_LINKED_CALENDAR]: (state, action) => {
    find(state, { id: action.payload }).visible = true
  },
  [calendarTypes.HIDE_LINKED_CALENDAR]: (state, action) => {
    find(state, { id: action.payload }).visible = false
  },
})
